import React, {useState} from "react"
import ImageGallery from "./image_gallery"
import FaIcon from "components/fa_icon"

const ImageGalleryManager = ({galleries}) => {
  const [is_open_states, set_is_open_states] =
    useState(galleries.map((gallery) => gallery.is_open))
  const toggle_display_gallery = (index) => {
    if (is_open_states[index]) {
      set_is_open_states(is_open_states.map(() => false))
      return
    }

    set_is_open_states(is_open_states.map((_, idx) => idx === index))
  }
  return (
    <>
      {galleries.map((gallery, index) =>
        <ImageGalleryTab
          key={index}
          index={index}
          gallery={gallery}
          is_open={is_open_states[index]}
          toggle_display_gallery={toggle_display_gallery}
        />
      )}
    </>
  )
}

const ImageGalleryTab = ({
  index,
  gallery,
  is_open,
  toggle_display_gallery
}) => (
  <div className={`image-gallery-tab ${is_open ? "open" : ""}`}>
    <div
      className="image-gallery-tab__header"
      onClick={() => toggle_display_gallery(index)}
    >
      {gallery.title}
      {is_open && <FaIcon name={"fa-chevron-up"}/>}
      {!is_open && <FaIcon name={"fa-chevron-down"}/>}
    </div>
    {is_open &&
      <ImageGallery {...gallery} />}
  </div>
)

export default ImageGalleryManager
